<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="选择时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetStaticData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box chart-body flex-wrap">
      <div class="data-count">
        <div class="flex-wrap">
          <div class="flex-con">
            <div class="order-count">
              <span>日均总学员数</span>
              <p class="bold">
                {{ basicData.rjzxy || 0 }}
              </p>
            </div>
          </div>
          <div class="flex-con">
            <div class="order-count">
              <span>日均正式学员</span>
              <p class="bold">
                {{ basicData.rjzsxy || 0 }}
              </p>
            </div>
          </div>
          <div class="flex-con">
            <div class="order-count">
              <span>日均体验学员</span>
              <p class="bold">
                {{ basicData.rjtyxy || 0 }}
              </p>
            </div>
          </div>
          <div class="flex-con">
            <div class="order-count">
              <span>日均新签学员</span>
              <p class="bold">
                {{ basicData.rjxqxy || 0 }}
              </p>
            </div>
          </div>
          <div class="flex-con">
            <div class="order-count">
              <span>日均续费学员</span>
              <p class="bold">
                {{ basicData.rjxfxy || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="年级" prop="name" fixed align="center" />
        <el-table-column label="总计" align="center">
          <el-table-column prop="L1" label="日均正式课耗人次" align="center" />
          <el-table-column prop="L2" label="日均体验课耗人次" align="center" />
          <el-table-column prop="L3" label="累计正式课耗人次" align="center" />
          <el-table-column prop="L4" label="累计体验课耗人次" align="center" />
          <el-table-column prop="L5" label="日均正式课耗金额" align="center" />
          <el-table-column prop="L6" label="日均体验课耗金额" align="center" />
          <el-table-column prop="L7" label="累计正式课耗金额" align="center" />
          <el-table-column prop="L8" label="累计体验课耗金额" align="center" />
        </el-table-column>
        <el-table-column label="语文" align="center">
          <el-table-column prop="L9" label="语文日均正式课耗人次" align="center" />
          <el-table-column prop="L10" label="语文日均体验课耗人次" align="center" />
          <el-table-column prop="L11" label="语文累计正式课耗人次" align="center" />
          <el-table-column prop="L12" label="语文累计体验课耗人次" align="center" />
          <el-table-column prop="L13" label="语文日均正式课耗金额" align="center" />
          <el-table-column prop="L14" label="语文日均体验课耗金额" align="center" />
          <el-table-column prop="L15" label="语文累计正式课耗金额" align="center" />
          <el-table-column prop="L16" label="语文累计体验课耗金额" align="center" />
        </el-table-column>
        <el-table-column label="数学" align="center">
          <el-table-column prop="L17" label="数学日均正式课耗人次" align="center" />
          <el-table-column prop="L18" label="数学日均体验课耗人次" align="center" />
          <el-table-column prop="L19" label="数学累计正式课耗人次" align="center" />
          <el-table-column prop="L20" label="数学累计体验课耗人次" align="center" />
          <el-table-column prop="L21" label="数学日均正式课耗金额" align="center" />
          <el-table-column prop="L22" label="数学日均体验课耗金额" align="center" />
          <el-table-column prop="L23" label="数学累计正式课耗金额" align="center" />
          <el-table-column prop="L24" label="数学累计体验课耗金额" align="center" />
        </el-table-column>
        <el-table-column label="英语" align="center">
          <el-table-column prop="L25" label="英语日均正式课耗人次" align="center" />
          <el-table-column prop="L26" label="英语日均体验课耗人次" align="center" />
          <el-table-column prop="L27" label="英语累计正式课耗人次" align="center" />
          <el-table-column prop="L28" label="英语累计体验课耗人次" align="center" />
          <el-table-column prop="L29" label="英语日均正式课耗金额" align="center" />
          <el-table-column prop="L30" label="英语日均体验课耗金额" align="center" />
          <el-table-column prop="L31" label="英语累计正式课耗金额" align="center" />
          <el-table-column prop="L32" label="英语累计体验课耗金额" align="center" />
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetStaticData" />
    </div>

  </div>

</template>
<script>

// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'
var moment = require('moment')

export default {
  name: 'TyyDoubleTestRecord',
  components: {

  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      basicData: '',
      listQuery: {
        p: 1,
        limit: 20,
        begin_time: '',
        end_time: '',
        total: 0,
        time: ''
      }
    }
  },
  created() {
    this.listQuery.time = [moment(new Date()).subtract(1, 'day').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    this.listQuery.begin_time = this.listQuery.time[0]
    this.listQuery.end_time = this.listQuery.time[1]
    this.fnGetStaticData()
  },
  methods: {
    fnGetStaticData: function() {
      this.$http.tyyOperateStatistic(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
        this.basicData = res.data.all
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    }
  }
}
</script>
<style lang="scss">
  .el-table thead.is-group th{
    background: #4c84ff!important;
  }
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}

.date-box {
    display: inline;
  }
  .chart-body {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .data-title {
    display: block;
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
  }
  .checkbox-item:first-child {
    width: 80px !important;
    margin-bottom: 20px;
  }
  .checkbox-item {
    width: 160px !important;
    margin-bottom: 20px;
  }
  .compare-data {
    margin-bottom: 50px;
    width: 760px;
    .title {
      color: black;
      font-size: 24px;
      margin-bottom: 20px;
    }
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .data-count {
    width: 100%;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 15px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
</style>
